<template>
    <div>
        <apexcharts width="100%"
            height="280"
            type="pie"
            :options="options"
            :series="series"
            v-if="!loading"></apexcharts>
    </div>
</template>

<script>
import _ from 'lodash'
import ordersService from '@/components/orders/services'
import ordersStatusService from '@/components/orders/services/ordersStatus'
import VueApexCharts from 'vue-apexcharts'

export default {
    name: 'StatisticsOrders',

    props: {
        admin: {
            type: Boolean,
            default: false
        }
    },

    components: {
        apexcharts: VueApexCharts
    },

    data () {
        return {
            options: {
                labels: [],
                colors: ['#70a1ff', '#7bed9f', '#ff7f50', '#ff4757']
            },

            series: [],

            loading: false
        }
    },

    methods: {
        async fetchOrders (statusId) {
            let parameters = {
                pagination: {
                },
                orderBy: {
                },
                filter: {
                    orderstatus_id: statusId
                }
            }

            if (!this.admin) {
                parameters.filter.organization_id = this.$store.getters.user.organizationId
            }

            let response = await ordersService.retrieve(parameters)
            return response.data.pagination.totalItems
        },

        async fetchOrderStatus () {
            let params = {
                filter: {
                    active: 1
                }
            }

            let response = await ordersStatusService.getOrdersStatus(params)
            return response.data.results
        },

        async generateValues () {
            let self = this
            self.loading = true

            let ordersStatus = await this.fetchOrderStatus()

            let ordersValues = []
            for (const orderStatus of ordersStatus) {
                let totalOrders = await this.fetchOrders(orderStatus.orderstatus_id)
                ordersValues.push(totalOrders)
            }

            self.options.labels = _.cloneDeep(_.reduce(
                ordersStatus,
                function (result, value, key) {
                    result.push(value.description)
                    return result
                },
                []
            ))
            self.series = _.cloneDeep(ordersValues)
            self.loading = false
        }
    },

    async mounted () {
        await this.generateValues()
    }
}
</script>
